/**
 * Tile - CTA Tile
 */
export class GMXCTATile extends HTMLElement {
	backgroundImgEl: HTMLImageElement
	overlayContainerEl: HTMLElement

	private boundHandleObservationCallback = this.handleObservation.bind(this)

	private intersectionObserver: IntersectionObserver
	private isVisible = false

	get isAnimate(): boolean {
		return this.getAttribute('data-to-animate') === 'true'
	}

	connectedCallback(): void {
		this.overlayContainerEl = this.querySelector('.content-overlay-container')
		this.backgroundImgEl = this.overlayContainerEl.querySelector('img.tile-bg-image')

		if (this.isAnimate) {
			if (!this.backgroundImgEl || this.backgroundImgEl.complete) {
				this.initTileForAnimations()
			} else {
				// Wait for image load finish loading before monitoring for animation
				this.backgroundImgEl.onload = () => {
					this.initTileForAnimations()
				}
			}
		}
	}

	disconnectedCallback(): void {
		if (this.isAnimate) {
			if (this.intersectionObserver) {
				this.intersectionObserver.unobserve(this)
			}
		}
	}

	/**
	 * If tile is set to animate, need to setup IntersectionObserver and window event listeners
	 * to be able to properly trigger animations.
	 */
	initTileForAnimations(): void {
		const bounds = this.getBoundingClientRect()

		if (bounds.bottom < 0 || bounds.top < 0) {
			// If the tile is below the fold or within the viewing area, force the animation
			this.setAttribute('data-animate', '')
		} else {
			// Setup 'watcher' for when comes in and out of view
			this.intersectionObserver = new IntersectionObserver(this.boundHandleObservationCallback, {
				root: null,
				rootMargin: '0px',
				threshold: 0.5,
			})
			this.intersectionObserver.observe(this)
		}
	}

	/**
	 * Callback for when the IntersectionObserver triggers an observation event
	 * @param entries
	 */
	handleObservation(entries: IntersectionObserverEntry[]): void {
		entries.forEach(entry => {
			this.isVisible = entry.isIntersecting

			if (this.isVisible) {
				this.setAttribute('data-animate', '')
				this.intersectionObserver.unobserve(this)
			}
		})
	}
}

if (!customElements.get('gmx-cta-tile')) {
	customElements.define('gmx-cta-tile', GMXCTATile)
}
